import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const {
    colorText,
    colorBorderInputFocus,
    colorBorderInteractive,
    space025,
    space3,
    space4,
    space6,
    borderWidth1,
    borderWidth2,
    borderRadius3,
  } = theme();

  return StyleSheet.create({
    container: {
      gap: space3,
    },
    modalContent: {
      paddingHorizontal: space6,
    },
    modalTitle: {
      marginBottom: space3,
    },
    text: {
      color: colorText,
      flex: 1,
      marginLeft: space4,
    },
    wrapper: {
      alignItems: "center",
      borderColor: colorBorderInteractive,
      borderWidth: borderWidth1,
      flex: 1,
      flexDirection: "row",
      padding: space4,
    },
    wrapperChecked: {
      borderColor: colorBorderInputFocus,
      borderWidth: borderWidth2,
      padding: space4 - space025,
    },
    wrapperLookiero: {
      borderRadius: borderRadius3,
    },
  });
};

export { style };
